"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("@emotion/styled"));
exports.default = styled_1.default.div `
  flex: 1;
  .expense_record_title {
    @media (max-width: 768px) {
      padding: 16px;
    }
    padding: 0 0 16px;
  }
  .expense_record_grid {
    display: grid;
    border-top: 1px solid var(--gray-5);
    border-bottom: 1px solid var(--gray-5);
    @media (max-width: 768px) {
      grid-template-columns: 1.4fr 1.2fr 1fr;
    }
    grid-template-columns: 2fr 1fr 1fr;
    gap: 1px;
    background-color: var(--gray-10);
    > * {
      display: flex;
    }
    .top_row {
      align-items: center;
      justify-content: center;
      height: 40px;
      padding: 10px;
      background-color: var(--table-row);
    }
    .desc_column {
      flex-direction: column;
      justify-content: center;
      row-gap: 6px;
      padding: 10px 16px;
      .desc_with_detail {
        display: flex;
        align-items: center;
        column-gap: 2px;
      }
    }
    .amount_column {
      align-items: center;
      justify-content: flex-end;
      padding: 6px 10px;
    }
    .file_column {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 6px 10px;
      text-align: center;
      word-break: break-word;
    }
  }
  .expense_record_register {
    display: flex;
    justify-content: flex-end;
    column-gap: 10px;
    padding: 16px 16px 20px;
    button {
      column-gap: 4px;
      min-width: 88px;
      height: 32px;
      padding: 0 12px;
      border-radius: 6px;
      line-height: 22px;
      font-size: 15px;
    }
  }
`;
